import React, { Component } from 'react';
import Clappr from 'clappr';

export default class VideoPlayer extends Component {
  componentWillReceiveProps(nextProps) {
    this.player.stop();
    this.renderPlayer(nextProps);
  }

  render() {
    return <div className="video-wrapper" ref={ this.props.id } />
  }

  componentDidMount() {
    this.playerElement = this.refs[this.props.id];
    this.renderPlayer(this.props);
  }

  componentWillUnmount() {
    this.player.destroy();
  }

  renderPlayer(props) {
    if (this.player) {
      this.player.destroy();
    }

    this.player = new Clappr.Player({
      baseUrl: 'clappr',
      source: props.source,
      poster: props.poster,
      height: '100%',
      width: '100%',
      playbackNotSupportedMessage: 'Vídeo indisponível. Verifique os equipamentos.'
    });

    this.player.attachTo(this.playerElement);
    this.player.play();
  }
}



// WEBPACK FOOTER //
// ./src/components/VideoPlayer.js